export var SET_SETTINGS = '[SETTINGS] SET SETTINGS';
export var SET_DEFAULT_SETTINGS = '[SETTINGS] SET DEFAULT SETTINGS';
export var RESET_DEFAULT_SETTINGS = '[SETTINGS] RESET DEFAULT SETTINGS';
export function setSettings(value) {
    return {
        type: SET_SETTINGS,
        value: value,
    };
}
export function setDefaultSettings(value) {
    return {
        type: SET_DEFAULT_SETTINGS,
        value: value,
    };
}
export function resetSettings(value) {
    return {
        type: RESET_DEFAULT_SETTINGS,
        value: value,
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/fuse/settings.actions.ts
// module id = 320
// module chunks = 81